// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SignalStatusSchema = z.enum(['POTENTIAL_VULNERABILITY','BLOCKED','CONFIRMED_VULNERABILITY','DISPROVEN_VULNERABILITY','DUPLICATE','PENDING_ENRICHMENT','FAILED_ENRICHMENT'] as const);

export type SignalStatusType = `${z.infer<typeof SignalStatusSchema>}`

export default SignalStatusSchema;
